var onDOMLoaded = function() {
  // Change home page button redirect address
  const requestDemoButton = document.querySelector('.template-index .sf__featured-collection-button .sf__btn');
  
  if (requestDemoButton) {
    requestDemoButton.setAttribute('href', 'https://apps.shopify.com/teeinblue?utm_campaign=Demo_Store&utm_medium=Demo_Home_Page&utm_source=Button_feature_product');
    requestDemoButton.setAttribute('target', '_blank');
  }

  // Add CSS class for elements
  document.querySelectorAll('.homepage-custom-content .content__heading').forEach(function(heading) {
    heading.classList.add('section__heading');
  });
  
  // Add redirect link behind reviews
  const reviews = document.querySelector('.template-index .sf-testimonials > div');
  
  if (reviews) {
    const wrapper = document.createElement('div');
    
    wrapper.setAttribute('class', 'mt-6 text-center');
    wrapper.innerHTML = '<a href="https://apps.shopify.com/teeinblue/reviews?utm_campaign=demo_store&utm_medium=home_page&utm_source=review" class="sf__btn sf__btn-link" target="_blank">See more reviews</a>';
    reviews.appendChild(wrapper);
  }
};

onDOMLoaded();